import { Constants } from '../../../constants';
import { numWithCommas } from '../../../utils/utils';

export const numAsPercent = number => {
  if (isNaN(number)) return Constants.fallback;
  return `${numWithCommas(Math.abs(number))}%`;
};
